export default "/images/ec518e0f713878632324d08776f55449.png";